import { render, staticRenderFns } from "./ClipboardWithDirective.vue?vue&type=template&id=4b484d4e&"
import script from "./ClipboardWithDirective.vue?vue&type=script&lang=js&"
export * from "./ClipboardWithDirective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports